import { Button } from 'antd';
import { DeleteFilled } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { useAppDispatch } from 'utilities/hooks';
import { fetchDeletedDocuments, foreverDeleteTrashed } from 'slices/documentsActions';

export const DocumentsToolbarButtonEmptyBin: React.FC = () => {
    const dispatch = useAppDispatch();
    const { openModal: openConfirmationDeleteForeverAllModal } = useModal();

    const handleConfirmDeleteForeverAll = () => {
        dispatch(foreverDeleteTrashed())
            .unwrap()
            .then(() => {
                dispatch(fetchDeletedDocuments());
            })
            .catch(() => {});
    };

    return (
        <Button
            type="primary"
            onClick={() => {
                openConfirmationDeleteForeverAllModal(
                    'confirmationModal',
                    {
                        text: 'Are you sure want to delete all item(s) forever?',
                    },
                    {
                        onConfirm: handleConfirmDeleteForeverAll,
                    },
                );
            }}
            icon={<DeleteFilled />}
        >
            Empty Bin
        </Button>
    );
};
